import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import PropTypes from 'prop-types';
import DocConfigActions from '@Actions/docConfigActions';
import EntityDocumentTypeConfiguration from '../EntityDocumentTypeConfiguration';
import './style.scss';

const { TabPane } = Tabs;

function EntityTab({
  user, getDocConfig, entityName, tab, docTab, docConfigProduct, docConfigPO, docConfigGRN, docConfigSO, docConfigSE, docConfigPS, docConfigInvoice,
  docConfigMO, docConfigJW, docConfigVendorPayout, docConfigStockTransfer, docConfigStockAdjustment, docConfigDeliveryChallan, docConfigDebitNote,
  docConfigCustomer, docConfigVendor, docConfigExpense, docConfigBOM, docConfigCreditNote, getDocConfigProductLoading,
  getDocConfigPOLoading, getDocConfigGRNLoading, getDocConfigSOLoading, getDocConfigInvoiceLoading, getDocConfigMOLoading, getDocConfigJWLoading,
  getDocConfigVendorPayoutLoading, updateDocConfigLoading, getDocConfigStockTransferLoading, getDocConfigStockAdjustmentLoading,
  getDocConfigExpenseLoading, getDocConfigBOMLoading, getDocConfigDeliveryChallanLoading, getDocConfigVendorLoading,
  getDocConfigCustomerLoading, getDocConfigDebitNoteLoading, getDocConfigCreditNoteLoading, getDocConfigRFQLoading,
  docConfigRFQ, docConfigPR, getDocConfigPRLoading, docConfigPI, getDocConfigPILoading, getDocConfigQCLoading, docConfigQC, docConfigDN, getDocConfigDNLoading, getDocConfigSELoading, getDocConfigPSLoading, 
  docConfigMPE, getDocConfigMPELoading, docConfigAnnualMaintenanceContract, getDocConfigAnnualMaintenanceContractLoading, docConfigReturnSlip, getDocConfigReturnSlipLoading, docConfigCO, getDocConfigCOLoading,
  getDocConfigAPInvoiceLoading, docConfigAPInvoice,
}) {
  const [currentDocTypeTab, setCurrentDocTypeTab] = useState('PURCHASE_ORDER_DOWNLOAD');
  const [call, setCall] = useState(false);

  useEffect(() => {
    getDocConfig(user?.tenant_info?.tenant_id, entityName, (doc) => {
      const key = new URLSearchParams(location.search).get('docTypeTab');
      setCurrentDocTypeTab(key || doc?.data?.[0]?.document_type);
    });
  }, []);

  useEffect(() => {
    if (call) {
      getDocConfig(user?.tenant_info?.tenant_id, entityName, (doc) => {
        setCurrentDocTypeTab(doc?.data?.[0]?.document_type);
        setCall(false);
      });
    }
  }, [call]);

  const getDataSource = () => {
    if (entityName === 'PRODUCTS') {
      const docConfig = docConfigProduct;
      return docConfig;
    }
    if (entityName === 'PURCHASE_ORDER') {
      const docConfig = docConfigPO;
      return docConfig;
    }
    if (entityName === 'GOOD_RECEIVING_NOTES') {
      const docConfig = docConfigGRN;
      return docConfig;
    }
    if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
      const docConfig = docConfigAPInvoice;
      return docConfig;
    }
    if (entityName === 'SALES_ESTIMATE') {
      const docConfig = docConfigSE;
      return docConfig;
    }
    if (entityName === 'SALES_ORDER') {
      const docConfig = docConfigSO;
      return docConfig;
    }
    if (entityName === 'PACKING_SLIP') {
      const docConfig = docConfigPS;
      return docConfig;
    }
    if (entityName === 'INVOICE') {
      const docConfig = docConfigInvoice;
      return docConfig;
    }
    if (entityName === 'MANUFACTURING_ORDER') {
      const docConfig = docConfigMO;
      return docConfig;
    }
    if (entityName === 'MANUAL_PRODUCTION_ENTRY') {
      const docConfig = docConfigMPE;
      return docConfig;
    }
    if (entityName === 'JOB_WORK') {
      const docConfig = docConfigJW;
      return docConfig;
    }
    if (entityName === 'VENDOR_PAYOUT') {
      const docConfig = docConfigVendorPayout;
      return docConfig;
    }
    if (entityName === 'STOCK_TRANSFER') {
      const docConfig = docConfigStockTransfer;
      return docConfig;
    }
    if (entityName === 'STOCK_ADJUSTMENT') {
      const docConfig = docConfigStockAdjustment;
      return docConfig;
    }
    if (entityName === 'debit_note') {
      const docConfig = docConfigDebitNote;
      return docConfig;
    }
    if (entityName === 'CREDIT_NOTE') {
      const docConfig = docConfigCreditNote;
      return docConfig;
    }
    if (entityName === 'RETURN_SLIP') {
      const docConfig = docConfigReturnSlip;
      return docConfig;
    }
    if (entityName === 'DELIVERY_CHALLAN') {
      const docConfig = docConfigDeliveryChallan;
      return docConfig;
    }
    if (entityName === 'VENDORS') {
      const docConfig = docConfigVendor;
      return docConfig;
    }
    if (entityName === 'CUSTOMERS') {
      const docConfig = docConfigCustomer;
      return docConfig;
    }
    if (entityName === 'EXPENSE') {
      const docConfig = docConfigExpense;
      return docConfig;
    }
    if (entityName === 'BILL_OF_MATERIAL') {
      const docConfig = docConfigBOM;
      return docConfig;
    }
    if (entityName === 'REQUEST_FOR_QUOTATION') {
      const docConfig = docConfigRFQ;
      return docConfig;
    }
    if (entityName === 'PURCHASE_REQUEST') {
      const docConfig = docConfigPR;
      return docConfig;
    }
    if (entityName === 'PURCHASE_INDENT') {
      const docConfig = docConfigPI;
      return docConfig;
    }
    if (entityName === 'QUALITY_CHECKS') {
      const docConfig = docConfigQC;
      return docConfig;
    }
    if (entityName === 'DEBIT_NOTE') {
      const docConfig = docConfigDN;
      return docConfig;
    }
    if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
      const docConfig = docConfigAnnualMaintenanceContract;
      return docConfig;
    }
    if (entityName === 'CONSUMPTION_ORDER') {
      const docConfig = docConfigCO;
      return docConfig;
    }
    return {};
  };

  const getDataSourceLoading = () => {
    if (entityName === 'PRODUCTS') {
      const getDocConfigLoading = getDocConfigProductLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'PURCHASE_ORDER') {
      const getDocConfigLoading = getDocConfigPOLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'GOOD_RECEIVING_NOTES') {
      const getDocConfigLoading = getDocConfigGRNLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
      const getDocConfigLoading = getDocConfigAPInvoiceLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'SALES_ESTIMATE') {
      const getDocConfigLoading = getDocConfigSELoading;
      return getDocConfigLoading;
    }
    if (entityName === 'SALES_ORDER') {
      const getDocConfigLoading = getDocConfigSOLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'PACKING_SLIP') {
      const getDocConfigLoading = getDocConfigPSLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'INVOICE') {
      const getDocConfigLoading = getDocConfigInvoiceLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'MANUFACTURING_ORDER') {
      const getDocConfigLoading = getDocConfigMOLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'MANUAL_PRODUCTION_ENTRY') {
      const getDocConfigLoading = getDocConfigMPELoading;
      return getDocConfigLoading;
    }
    if (entityName === 'JOB_WORK') {
      const getDocConfigLoading = getDocConfigJWLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'VENDOR_PAYOUT') {
      const getDocConfigLoading = getDocConfigVendorPayoutLoading;
      return getDocConfigLoading;
    }
    if (entityName === 'STOCK_TRANSFER') {
      const docConfig = getDocConfigStockTransferLoading;
      return docConfig;
    }
    if (entityName === 'STOCK_ADJUSTMENT') {
      const docConfig = getDocConfigStockAdjustmentLoading;
      return docConfig;
    }
    if (entityName === 'debit_note') {
      const docConfig = getDocConfigDebitNoteLoading;
      return docConfig;
    }
    if (entityName === 'CREDIT_NOTE') {
      const docConfig = getDocConfigCreditNoteLoading;
      return docConfig;
    }
    if (entityName === 'RETURN_SLIP') {
      const docConfig = getDocConfigReturnSlipLoading;
      return docConfig;
    }
    if (entityName === 'DELIVERY_CHALLAN') {
      const docConfig = getDocConfigDeliveryChallanLoading;
      return docConfig;
    }
    if (entityName === 'VENDORS') {
      const docConfig = getDocConfigVendorLoading;
      return docConfig;
    }
    if (entityName === 'CUSTOMERS') {
      const docConfig = getDocConfigCustomerLoading;
      return docConfig;
    }
    if (entityName === 'EXPENSE') {
      const docConfig = getDocConfigExpenseLoading;
      return docConfig;
    }
    if (entityName === 'BILL_OF_MATERIAL') {
      const docConfig = getDocConfigBOMLoading;
      return docConfig;
    }
    if (entityName === 'REQUEST_FOR_QUOTATION') {
      const docConfig = getDocConfigRFQLoading;
      return docConfig;
    }
    if (entityName === 'PURCHASE_REQUEST') {
      const docConfig = getDocConfigPRLoading;
      return docConfig;
    }
    if (entityName === 'PURCHASE_INDENT') {
      const docConfig = getDocConfigPILoading;
      return docConfig;
    }
    if (entityName === 'QUALITY_CHECKS') {
      const docConfig = getDocConfigQCLoading;
      return docConfig;
    }
    if (entityName === 'DEBIT_NOTE') {
      const docConfig = getDocConfigDNLoading;
      return docConfig;
    }
    if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
      const docConfig = getDocConfigAnnualMaintenanceContractLoading;
      return docConfig;
    }
    if (entityName === 'CONSUMPTION_ORDER') {
      const docConfig = getDocConfigCOLoading;
      return docConfig;
    }
    return true;
  };

  return (
    <Fragment>
      {getDataSourceLoading() ? (
        <Fragment>
          <div className="entity-tab__loading-wrapper">
            <div className="entity-tab__loading-tabs">
              <div className="loadingBlock entity-tab__loading-tab" />
            </div>

            <div className="entity-tab__loading-inputs">
              <div className="ant-row">
                {[1, 2]?.map((item) => (
                  <div key={item} className="ant-col-md-8">
                    <div className="entity-tab__loading-input-wrapper">
                      <div className="loadingBlock entity-tab__loading-input" style={{ height: '200px' }} />
                    </div>
                  </div>
                ))}
                {[1, 2]?.map((item) => (
                  <div key={item} className="ant-col-md-24">
                    <div className="entity-tab__loading-input-wrapper" style={{ width: '50%' }}>
                      <div className="loadingBlock entity-tab__loading-input" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="entity-tab__loading-check-wrapper">
              <div className="loadingBlock entity-tab__loading-check-box" />
              <div className="loadingBlock entity-tab__loading-check-label" />
            </div>
            <div className="entity-tab__loading-check-wrapper">
              <div className="loadingBlock entity-tab__loading-check-box" />
              <div className="loadingBlock entity-tab__loading-check-label" />
            </div>
          </div>
        </Fragment>
      ) : (
        <div
          style={{
            overflowY: 'auto',
            maxHeight: 'calc(80dvh - 62px)',
            overflowX: 'hidden',
          }}
        >
          {getDataSource()?.data?.map((docType) => (
            <EntityDocumentTypeConfiguration key={entityName} entityName={entityName} docType={docType.document_type} allowedFields={docType?.allowed_fields} loading={updateDocConfigLoading} callback={() => setCall(true)} />
          ))}
        </div>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DocConfigReducers,
}) => ({
  user: UserReducers.user,
  getDocConfigProductLoading: DocConfigReducers.getDocConfigProductLoading,
  getDocConfigPOLoading: DocConfigReducers.getDocConfigPOLoading,
  getDocConfigGRNLoading: DocConfigReducers.getDocConfigGRNLoading,
  getDocConfigAPInvoiceLoading: DocConfigReducers.getDocConfigAPInvoiceLoading,
  getDocConfigSELoading: DocConfigReducers.getDocConfigSELoading,
  getDocConfigSOLoading: DocConfigReducers.getDocConfigSOLoading,
  getDocConfigPSLoading: DocConfigReducers.getDocConfigPSLoading,
  getDocConfigInvoiceLoading: DocConfigReducers.getDocConfigInvoiceLoading,
  getDocConfigMOLoading: DocConfigReducers.getDocConfigMOLoading,
  getDocConfigMPELoading: DocConfigReducers.getDocConfigMPELoading,
  getDocConfigJWLoading: DocConfigReducers.getDocConfigJWLoading,
  getDocConfigVendorPayoutLoading: DocConfigReducers.getDocConfigVendorPayoutLoading,
  getDocConfigStockTransferLoading: DocConfigReducers.getDocConfigStockTransferLoading,
  getDocConfigStockAdjustmentLoading: DocConfigReducers.getDocConfigStockAdjustmentLoading,
  getDocConfigDebitNoteLoading: DocConfigReducers.getDocConfigDebitNoteLoading,
  getDocConfigCreditNoteLoading: DocConfigReducers.getDocConfigCreditNoteLoading,
  getDocConfigReturnSlipLoading: DocConfigReducers.getDocConfigReturnSlipLoading,
  getDocConfigDeliveryChallanLoading: DocConfigReducers.getDocConfigDeliveryChallanLoading,
  getDocConfigVendorLoading: DocConfigReducers.getDocConfigVendorLoading,
  getDocConfigCustomerLoading: DocConfigReducers.getDocConfigCustomerLoading,
  getDocConfigExpenseLoading: DocConfigReducers.getDocConfigExpenseLoading,
  getDocConfigBOMLoading: DocConfigReducers.getDocConfigBOMLoading,
  getDocConfigRFQLoading: DocConfigReducers.getDocConfigRFQLoading,
  getDocConfigPILoading: DocConfigReducers.getDocConfigPILoading,
  getDocConfigDNLoading: DocConfigReducers.getDocConfigDNLoading,

  docConfigProduct: DocConfigReducers.docConfigProduct,
  docConfigPO: DocConfigReducers.docConfigPO,
  docConfigGRN: DocConfigReducers.docConfigGRN,
  docConfigAPInvoice: DocConfigReducers.docConfigAPInvoice,
  docConfigSE: DocConfigReducers.docConfigSE,
  docConfigSO: DocConfigReducers.docConfigSO,
  docConfigPS: DocConfigReducers.docConfigPS,
  docConfigInvoice: DocConfigReducers.docConfigInvoice,
  docConfigMO: DocConfigReducers.docConfigMO,
  docConfigMPE: DocConfigReducers.docConfigMPE,
  docConfigJW: DocConfigReducers.docConfigJW,
  docConfigVendorPayout: DocConfigReducers.docConfigVendorPayout,
  addDocConfigLoading: DocConfigReducers.addDocConfigLoading,
  docConfigStockTransfer: DocConfigReducers.docConfigStockTransfer,
  docConfigStockAdjustment: DocConfigReducers.docConfigStockAdjustment,
  docConfigDebitNote: DocConfigReducers.docConfigDebitNote,
  docConfigCreditNote: DocConfigReducers.docConfigCreditNote,
  docConfigReturnSlip: DocConfigReducers.docConfigReturnSlip,
  docConfigDeliveryChallan: DocConfigReducers.docConfigDeliveryChallan,
  docConfigVendor: DocConfigReducers.docConfigVendor,
  docConfigCustomer: DocConfigReducers.docConfigCustomer,
  docConfigExpense: DocConfigReducers.docConfigExpense,
  docConfigBOM: DocConfigReducers.docConfigBOM,
  docConfigRFQ: DocConfigReducers.docConfigRFQ,
  docConfigPR: DocConfigReducers.docConfigPR,
  docConfigPI: DocConfigReducers.docConfigPI,
  docConfigCO: DocConfigReducers.docConfigCO,
  getDocConfigPRLoading: DocConfigReducers.getDocConfigPRLoading,
  updateDocConfigLoading: DocConfigReducers.updateDocConfigLoading,
  getDocConfigQCLoading: DocConfigReducers.getDocConfigQCLoading,
  docConfigQC: DocConfigReducers.docConfigQC,
  docConfigDN: DocConfigReducers.docConfigDN,
  docConfigAnnualMaintenanceContract: DocConfigReducers.docConfigAnnualMaintenanceContract,
  getDocConfigAnnualMaintenanceContractLoading: DocConfigReducers.getDocConfigAnnualMaintenanceContractLoading,
  getDocConfigCOLoading: DocConfigReducers.getDocConfigCOLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EntityTab));
